import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../theme';
import { zIndex } from '../../constants/zIndex';

interface NavigationProps {
  children?: React.ReactNode;
}

export const Navigation: React.FC<NavigationProps> = ({ children }) => {

  return (
    <Box
      component="nav"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: zIndex.header,
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: colors.deepNavy,
        borderBottom: `1px solid ${colors.whiteAlpha[10]}`,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          color: colors.pureWhite,
          letterSpacing: '-0.01em',
          fontSize: '1.5rem',
        }}
      >
        filtrd.io
      </Typography>
      {children}
    </Box>
  );
};
